<div class="address-form-container" *transloco="let t;">
    <div class="header-wrapper">
        <span class="form-title">{{t('modals.edit_address_modal.edit_title', {title: editTitle()})}}</span>
        <button class="button-undecorated" style="border-radius: 100%;" [attr.aria-label]="'Close ' + t('modals.edit_address_modal.edit_title', {title: editTitle()})"
            (click)="closeModal()">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    <div class="address-form-wrapper">
        <cwo-address-form #addressFormComponent
            [address]="savedAddress()!"
            [isAccountPage]="true"
            [editing]="true"
            [validationResponse]="validationResponse"
            (isFormValid)="handleAddressFormValidation($event)"
            (overrideAddress)="handleOverrideAddress()"
            (noThankYou)="handleNoThankyou()"
            (formChanging)="handleFormChanging()"
            [allErrors]="serverErrors"
        />
    </div>
    <div class="button-container">
        <button cwoAsyncButton [subscription]="loadingSubscription" class="button-accent submit-button" (click)="onSubmit()">
            {{t('modals.edit_address_modal.done')}}
        </button>
    </div>
</div>